import { ChangeDetectionStrategy, Component, inject, input, ViewContainerRef } from '@angular/core';
import { OverlayscrollbarsModule } from 'overlayscrollbars-ngx';
import { OverlayScrollbarOptions } from '../../types/overlay-scrollbar.types';
import { ScrollbarDirective } from '@directives/scrollbar.directive';

export const scrollOptions: OverlayScrollbarOptions = {
  paddingAbsolute: true,
  scrollbars: {
    theme: 'os-theme-light',
    visibility: 'auto' as any,
    autoHide: 'never',
    autoHideDelay: 1300,
    autoHideSuspend: false,
    dragScroll: true,
    clickScroll: false,
  },
};

@Component({
  selector: 'cmp-scrollbar',
  standalone: true,
  imports: [OverlayscrollbarsModule],
  templateUrl: './scrollbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``,
  hostDirectives: [{ directive: ScrollbarDirective, inputs: ['options'] }],
})
export class ScrollbarComponent {
  vcr = inject(ViewContainerRef);
  scrollBarRef = inject(ScrollbarDirective);

  options = input(scrollOptions);

  constructor() {
    this.scrollBarRef.osInitialize(this.vcr.element.nativeElement);
  }
}
